import "./index.css";
import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components/macro";
import {
  ThemeProvider as DSThemeProvider,
  useTheme,
} from "@gcs/design-system/react";
import { envs } from "../config";

const DsConfig = ({ themeId, children }) => {
  return (
    <DSThemeProvider theme={themeId}>
      <ThemeProvider theme={useTheme(themeId)}>{children}</ThemeProvider>
    </DSThemeProvider>
  );
};

DsConfig.defaultProps = {
  themeId: envs.DsTheme || "caixa-seguradora",
};

DsConfig.propTypes = {
  themeId: PropTypes.string,
};

export default DsConfig;
